// extracted by mini-css-extract-plugin
module.exports = {"text":"ThemeToggleButton_text__1G_o8","container":"ThemeToggleButton_container__2FD57","icon":"ThemeToggleButton_icon__17ZMy"};